import { CountryCode } from '@/__generated__/storefront/graphql';

// This is a workaround for the issue where Shopify does not allow us to set a default country for markets with multiple countries.
const COUNTRY_OVERRIDE_MAP: Record<string, `${CountryCode}` | undefined> = {
  AX: 'FI'
};

export const getMarketCountryCode = () =>
  COUNTRY_OVERRIDE_MAP[window.Shopify.country] ?? window.Shopify.country;

export const storeCountryCode = () => {
  return window.Hobbii?.storeDefaultCountryCode || window.Shopify.country;
};
